export enum KPI_ERROR {
    Configuration_Exists = "Configuration_Exists",
}

export enum NAVIGATION_LABEL {
    CREATE = 'Configure KPI insights',
    EDIT = 'Edit configurations'
}

export enum MAIN_TITLE {
    CREATE = 'Configure KPI insights',
    EDIT = 'Edit configurations'
}

export enum NOTE {
    CREATE = 'start adding KPIs through "Select KPIs" button',
    EDIT = 'Only "Action in" field can be configured. Name, Role, Department, AH level, Frequency are inherited from Smart KPI configurations'
}

export enum IaConfigEditStatusBody {
    SUCCESS =  'Changes were saved successfully',
    FAILED = 'Changes were not saved successfully'
}